<template>
  <div class="body">
    <div class="logo_header">
      <!-- <div class="logo">
        <img src="../../assets/logo.png" style="height: 80px;" alt="" />
      </div> -->
    </div>
    <div
      class="login-banner"
      v-loading="loading"
      element-loading-text="登录中，请稍后"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="container">
        <div
          id="alert"
          style="background: transparent"
          v-show="wxShow === false && companyWxShow === false"
        ></div>

        <div id="alert" v-show="wxShow">
          <div id="login_container" ref="login_container"></div>
        </div>

        <div id="alert" v-show="companyWxShow">
          <div
            id="company_login_container"
            ref="company_login_container"
            v-show="companyWxShow"
          ></div>
        </div>

        <div class="login-box">
          <!-- <span class="login_method" @click="showCompany = !showCompany">
            {{ showCompany ? "微信扫码登录 ->" : "企业微信扫码登录 ->" }}
          </span> -->
          <div class="login-tab">
            <ul>
              <li
                :class="{ active: active == index }"
                v-for="(item, index) in tabList"
                :key="index"
                @click="tabClick(index)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="tab-pane" v-show="active == 0">
            <div class="login_form">
              <div class="iconfontBox">
                <img src="../../assets/icon-user.png" />
              </div>
              <input
                autofocus="autofocus"
                class="login_input"
                name="userName"
                type="text"
                value
                v-model="loginName"
                placeholder="公共/个人账号"
              />
            </div>
            <div class="login_form">
              <div class="iconfontBox">
                <img src="../../assets/icon-pwd.png" />
              </div>
              <input
                class="login_input"
                name="passWord"
                ref="pwd"
                type="password"
                @keyup.enter="loginClick"
                value
                v-model="password"
                placeholder="密码"
              />
              <div class="sc">
                <!-- <i class="el-icon-view" @click="handleChangeType"></i> -->
                <img
                  class="sc_eye"
                  v-if="showEye"
                  src="../../assets/eye.png"
                  alt=""
                  @click="handleChangeType"
                />
                <img
                  class="sc_eye"
                  v-else
                  src="../../assets/eye-close.png"
                  alt=""
                  @click="handleChangeType"
                />
              </div>
            </div>
            <div class="automatic">
              <el-checkbox v-model="automaticchecked">七天自动登录</el-checkbox>
            </div>
            <div class="login_btn" @click="loginClick">登&nbsp;&nbsp;录</div>

            <div class="code_btn">
              <img
                class="code_img"
                src="../../assets/wx.svg"
                @click="
                  companyWxShow = false;
                  wxShow = !wxShow;
                "
              />
              <img
                class="code_img"
                src="../../assets/qywx.svg"
                @click="
                  wxShow = false;
                  companyWxShow = !companyWxShow;
                "
              />
              <span style="color: #666; font-size: 13px;"
                >微信/企业微信扫码登录</span
              >
            </div>

            <!-- <div class="login_btn_register" @click="register">注&nbsp;&nbsp;册</div> -->
          </div>
          <div class="tab-pane" v-show="active == 1">
            <div class="login_form">
              <div class="iconfontBox">
                <!-- <span class="iconfont icon-shoujihao"></span> -->
                <img src="../../assets/icon-phone.png" />
              </div>
              <input
                autofocus="autofocus"
                class="login_input"
                name="userName"
                type="text"
                value
                v-model="phone"
                placeholder="手机号码"
              />
            </div>
            <div class="login_form">
              <div class="iconfontBox">
                <!-- <span class="iconfont icon-yanzhengma1"></span> -->
                <img src="../../assets/icon-pwd.png" />
              </div>
              <span
                id="smsbtn"
                class="btn-code"
                v-show="!identifying"
                @click="sendSMS"
                >获取验证码</span
              >
              <span id="smsbtn" class="btn-code active" v-show="identifying"
                >{{ SMSCode }}秒后重新获取</span
              >
              <input
                class="login_input"
                type="text"
                @keyup.enter="ificationLogin"
                value
                v-model="verificationCode"
                placeholder="验证码"
              />
            </div>
            <div class="login_btn" @click="ificationLogin">
              登&nbsp;&nbsp;录
            </div>

            <div class="code_btn">
              <img
                class="code_img"
                src="../../assets/wx.svg"
                @click="
                  companyWxShow = false;
                  wxShow = !wxShow;
                "
              />
              <img
                class="code_img"
                src="../../assets/qywx.svg"
                @click="
                  wxShow = false;
                  companyWxShow = !companyWxShow;
                "
              />
              <span style="color: #666; font-size: 13px;"
                >微信/企业微信扫码登录</span
              >
            </div>

            <!-- <div class="login_btn_register" @click="register">注&nbsp;&nbsp;册</div> -->
          </div>
          <div class="tab-pane" v-show="active == 2"></div>
          <!-- <div
            class="viewCode"
            style="padding-bottom: 5px;fontSize:12px"
          >系统使用浏览器要求：谷歌浏览器、火狐浏览器、360极速浏览器</div>-->
          <!-- <p class="login_p" v-show="active < 2">欢迎使用博库数据库平台</p> -->
        </div>
      </div>
    </div>
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="changePwdVisible"
      width="600px"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div class="change-pwd-tip">
        <i class="el-icon-warning" style="color:#E6A23C;margin-right:6px;"></i>
        为保证账号安全，密码强度较低的用户请及时修改密码。
      </div>
      <el-form label-width="80px" style="margin-top:20px;">
        <el-form-item label="新密码">
          <el-input
            v-model="newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input
            v-model="confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          type="primary"
          :loading="changePwdLoading"
          @click="submitChangePwd"
          >确认修改</el-button
        >
      </span>
    </el-dialog>

    <div class="footer">
      版权所有@浙江省中医药研究院
      <el-link type="success" href="https://beian.miit.gov.cn" target="_blank"
        >浙ICP备18004034号-8
      </el-link>
      <br />联系电话：0571-86680878
    </div>
  </div>
</template>
<script>
export default {
  name: "Institute",
  data() {
    return {
      automaticchecked: JSON.parse(localStorage.getItem("usnstate")) || false,
      appid: "", //微信二维码所需
      openid: "",
      qyAppid: "",
      qyOpenid: "",
      redirectUri: "",
      loginName: localStorage.getItem("usn") || "",
      password: localStorage.getItem("pdw") || "",
      tabList: ["账号登录", "手机登录"],
      active: 0,
      phone: "",
      identifying: false,
      SMSCode: 60,
      verificationCode: "",
      SMSkey: "",
      loading: false,
      showCompany: false,
      wxShow: false,
      companyWxShow: false,
      showEye: false,
      // 修改密码弹窗
      changePwdVisible: false,
      changePwdToken: "",
      newPassword: "",
      confirmPassword: "",
      changePwdLoading: false,
      _pendingLoginData: null,
    };
  },
  created() {
    this.ipLogin();
    if (localStorage.getItem("autoKey")) {
      this.handleAutoLogin();
    }
    this.$api.wechatInfo().then((res) => {
      if (res.data.code == 200) {
        this.appid = res.data.data.appid;
        this.redirectUri = res.data.data.redirectUri;
        this.qyAppid = res.data.data.qyAppid;
        this.wxReload();
        this.companyWeChatScan();
      } else {
        this.$message.error(res.data.message);
      }
    });
    if (this.$route.query.appId) {
      sessionStorage.setItem("appidSys", this.$route.query.appId);
    }
    if (this.$route.query.code == 3081) {
      this.$alert("首次使用微信登录，请使用手机登录进行绑定", "提示", {
        confirmButtonText: "确定",
      });
      this.active = 1;
      this.qyOpenid = this.$route.query.message;
    }
    if (this.$route.query.code == 308) {
      this.$alert("首次使用微信登录，请使用手机登录进行绑定", "提示", {
        confirmButtonText: "确定",
      });
      this.active = 1;
      this.openid = this.$route.query.message;
      // sessionStorage.setItem("openId", this.$route.query.message);
    } else if (this.$route.query.code == 304) {
      this.$alert('"微信扫描登录失败,请使用其他方式登录', "提示", {
        confirmButtonText: "确定",
      });
      this.active = 0;
    }
    // let query = location.href.split("?");
    // if (query.length == 2) {
    //   let arr = query[1].split("&");
    //   this.loginName = arr[0].split("=")[1];
    //   this.password = arr[1].split("=")[1];
    //   this.loginClick();
    // }
  },
  methods: {
    _doRedirect(data, showMask = false) {
      if (data.reminder) {
        this.$alert(data.reminder, "提醒", {
          confirmButtonText: "确定",
          callback: () => {
            showMask
              ? this._fadeAndOpen(data.url)
              : window.open(data.url, "_self");
          },
        });
      } else {
        showMask ? this._fadeAndOpen(data.url) : window.open(data.url, "_self");
      }
    },
    _fadeAndOpen(url) {
      const styleEl = document.createElement("style");
      styleEl.textContent = `
        @keyframes _sl_in{from{opacity:0;transform:scale(1.02)}to{opacity:1;transform:scale(1)}}
        @keyframes _sl_card_in{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
        @keyframes _sl_ring{0%{stroke-dashoffset:220}100%{stroke-dashoffset:0}}
        @keyframes _sl_ring_rot{from{transform:rotate(-90deg)}to{transform:rotate(270deg)}}
        @keyframes _sl_pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.6;transform:scale(0.96)}}
        @keyframes _sl_fade_txt{0%,100%{opacity:0.4}50%{opacity:1}}
      `;
      document.head.appendChild(styleEl);

      const mask = document.createElement("div");
      mask.style.cssText =
        "position:fixed;inset:0;z-index:99999;background:rgba(248,250,252,0.92);display:flex;align-items:center;justify-content:center;animation:_sl_in 0.25s cubic-bezier(0.16,1,0.3,1) forwards;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);font-family:-apple-system,BlinkMacSystemFont,'PingFang SC','Microsoft YaHei',sans-serif;";

      mask.innerHTML = `
        <div style="display:flex;flex-direction:column;align-items:center;gap:20px;background:rgba(255,255,255,0.9);border:1px solid rgba(0,171,113,0.12);border-radius:20px;padding:36px 48px;box-shadow:0 8px 32px rgba(0,171,113,0.10),0 2px 8px rgba(0,0,0,0.06);animation:_sl_card_in 0.35s 0.05s cubic-bezier(0.16,1,0.3,1) both;">
          <div style="position:relative;width:56px;height:56px;animation:_sl_pulse 2s ease-in-out infinite;">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" style="position:absolute;inset:0;">
              <circle cx="28" cy="28" r="26" stroke="#e6f7f2" stroke-width="3" fill="none"/>
              <circle cx="28" cy="28" r="26" stroke="#00ab71" stroke-width="3" fill="none"
                stroke-dasharray="220" stroke-dashoffset="220" stroke-linecap="round"
                style="transform-origin:28px 28px;animation:_sl_ring 0.7s 0.1s cubic-bezier(0.4,0,0.2,1) forwards,_sl_ring_rot 1.8s 0.8s linear infinite;"/>
            </svg>
            <div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="#00ab71" opacity="0"/>
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#00ab71" opacity="0"/>
                <circle cx="12" cy="12" r="4" fill="#00ab71"/>
                <circle cx="12" cy="12" r="2" fill="white"/>
              </svg>
            </div>
          </div>
          <div style="display:flex;flex-direction:column;align-items:center;gap:6px;">
            <span style="font-size:15px;font-weight:600;color:#0a0a0a;letter-spacing:0.02em;">正在跳转</span>
          </div>
          <div style="display:flex;gap:5px;align-items:center;">
            <span style="width:5px;height:5px;border-radius:50%;background:#00ab71;display:inline-block;animation:_sl_fade_txt 1.2s 0s ease-in-out infinite;"></span>
            <span style="width:5px;height:5px;border-radius:50%;background:#00ab71;display:inline-block;animation:_sl_fade_txt 1.2s 0.2s ease-in-out infinite;"></span>
            <span style="width:5px;height:5px;border-radius:50%;background:#00ab71;display:inline-block;animation:_sl_fade_txt 1.2s 0.4s ease-in-out infinite;"></span>
          </div>
        </div>
      `;
      document.body.appendChild(mask);

      setTimeout(() => {
        styleEl.remove();
        window.open(url, "_self");
      }, 800);
    },
    submitChangePwd() {
      if (!this.newPassword) {
        this.$message.error("请输入新密码");
        return;
      }
      if (this.newPassword.length < 8) {
        this.$message.error("密码长度不能少于8位");
        return;
      }
      // if (!/^(?=.*[a-zA-Z])(?=.*\d).+$/.test(this.newPassword)) {
      //   this.$message.error("密码需包含字母和数字");
      //   return;
      // }
      if (this.newPassword !== this.confirmPassword) {
        this.$message.error("两次密码输入不一致");
        return;
      }
      this.changePwdLoading = true;
      this.$api
        .updateUserPwd({
          newpass: this.newPassword,
          token: this.changePwdToken,
        })
        .then((res) => {
          this.changePwdLoading = false;
          if (res.data.code == 200) {
            this.$message.success("密码修改成功");
            this.changePwdVisible = false;
            this._doRedirect(this._pendingLoginData, true);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          this.changePwdLoading = false;
          this.$message.error("网络异常，请稍后重试");
        });
    },
    register() {
      this.$router.push("/register");
    },
    handleChangeType() {
      if (this.$refs.pwd.type === "password") {
        this.showEye = true;
        this.$refs.pwd.type = "input";
      } else {
        this.showEye = false;
        this.$refs.pwd.type = "password";
      }
    },
    //ip登录
    ipLogin() {
      this.loading = true;
      this.$api
        .ssoLogin({
          type: "IP",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else if (res.data.code == 309) {
            this.loading = false;
            return;
          } else {
            this.loading = false;
            this.$message.error(res.data.message);
          }
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    //用户名密码登录
    loginClick() {
      this.loading = true;
      this.$api
        .ssoLogin({
          username: this.loginName,
          password: this.password,
          appId: sessionStorage.getItem("appidSys"),
          type: "USERNAME",
          // todo
          autoLogin: this.automaticchecked ? true : false,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            // console.log(res.data, "da");
            const { aid, dcode, realName, username } = res.data.data;
            const targetStrings = [
              "book_shanxi",
              "bookmed4",
              "book_med2",
              "book_med",
            ];
            // 使用 findIndex 方法在 targetStrings 数组中查找满足条件的元素的索引
            const foundIndex = targetStrings.findIndex((target) =>
              aid.includes(target),
            );
            if (foundIndex !== -1) {
              stat(dcode, 1, realName, username);
            }
            localStorage.setItem("uname", this.loginName);
            // autoLogin 逻辑提前，确保不被后续 return 跳过
            if (this.automaticchecked == true) {
              localStorage.setItem("usn", this.loginName);
              localStorage.setItem("pdw", this.password);
              localStorage.setItem("autoKey", res.data.data.autoKey);
              localStorage.setItem(
                "usnstate",
                JSON.stringify(this.automaticchecked),
              );
            } else {
              if (localStorage.getItem("usn")) {
                localStorage.removeItem("usn");
                localStorage.removeItem("pdw");
                localStorage.removeItem("usnstate");
                localStorage.removeItem("autoKey");
              }
            }
            // 判断是否修改过密码，0=未修改，弹窗提示
            // if (res.data.data.modifyPass === 0) {
            //   try {
            //     const urlObj = new URL(res.data.data.url);
            //     this.changePwdToken = urlObj.searchParams.get("bucToken") || "";
            //   } catch (e) {
            //     this.changePwdToken = "";
            //   }
            //   this.changePwdVisible = true;
            //   this._pendingLoginData = res.data.data;
            //   return;
            // }
            this._doRedirect(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    tabClick(index) {
      this.active = index;
      if (index == 2) {
        this.wxReload();
      }
    },
    wxReload() {
      var obj = new WxLogin({
        id: "login_container", //div的id
        appid: this.appid,
        scope: "snsapi_login", //写死
        redirect_uri: this.redirectUri,
        state: sessionStorage.getItem("appidSys"),
        style: "black", //二维码黑白风格
        href:
          "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDI0MHB4O2NvbG9yOiNkZGR9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ0K",
      });
    },
    companyWeChatScan() {
      // 初始化
      this.wwLogin = ww.createWWLoginPanel({
        el: "#company_login_container",
        params: {
          login_type: "ServiceApp",
          appid: this.qyAppid,
          redirect_uri: "https://www.medbooks.com.cn/#/wwLogin",
          state: "loginState",
          style: "black", //二维码黑白风格
          panel_size: "small",
        },
      });
      this.wwLogin.el.style = "width: 235px; height: 362px;";
    },
    sendSMS() {
      var reg = /^1[0-9]{10}$/;
      var flag = reg.test(this.phone);
      if (!flag) {
        this.$message.error("请输入正确手机号!");
        return;
      }
      let obj = {
        phone: this.phone,
      };
      this.$api.code(obj).then((res) => {
        if (res.data.code == 200) {
          this.identifying = true;
          this.SMSCode = 60;
          var Interval = setInterval(() => {
            this.SMSCode = this.SMSCode - 1;
            if (this.SMSCode == 0) {
              this.identifying = false;
              clearInterval(Interval);
            }
          }, 1000);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    ificationLogin() {
      this.loading = true;
      this.$api
        .ssoLogin({
          phone: this.phone,
          appId: sessionStorage.getItem("appidSys"),
          code: this.verificationCode,
          openid: this.openid,
          qyOpenid: this.qyOpenid,
          type: "TELPHONE",
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    handleAutoLogin() {
      this.loading = true;
      this.$api
        .autoLogin({
          autoKey: localStorage.getItem("autoKey"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.reminder) {
              this.$alert(res.data.data.reminder, "提醒", {
                confirmButtonText: "确定",
                callback: (action) => {
                  window.open(res.data.data.url, "_self");
                },
              });
            } else {
              window.open(res.data.data.url, "_self");
            }
          } else if (res.data.code == 309) {
            this.loading = false;
            return;
          } else {
            this.loading = false;
            // this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #000;
}

@media (max-width: 800px) {
  .footer,
  .logo_header,
  .login-banner {
    width: 900px !important;
  }

  .container {
    width: 900px !important;
    font-size: 10px;
  }
}

@media (min-width: 800px) and (max-width: 991px) {
  .container {
    width: 800px !important;
    font-size: 10px;
  }

  #alert {
    width: 230px !important;
    height: 363px !important;
  }

  #alert > ::v-deep .el-divider__text,
  .el-link {
    font-size: 10px;
  }

  .container .login_form {
    margin: 5px 0;
  }

  .container .login-box {
    margin-left: 10px;
  }

  .container .login-box,
  .container .login_p {
    margin-left: 20px;
    padding: 0;
  }

  .container .login_p {
    top: 160px;
  }

  .container .login-box {
    width: 250px;
    height: 200px !important;
  }

  .container .login-tab ul li {
    font-size: 14px;
  }

  .container .login_input,
  .container .login_btn {
    width: 220px !important;
  }

  .btn-code {
    left: 120px !important;
  }
}

@media (min-width: 992px) and (max-width: 1265px) {
  .container {
    width: 990px !important;
    font-size: 14px;
  }

  .container .login-box {
    margin-left: 20px;
  }
}

@media (min-width: 1266px) and (max-width: 1550px) {
  .container {
    font-size: 14px;
  }
}

@media (min-width: 1550px) {
  .container {
    font-size: 16px;
  }
}

.sc {
  position: absolute;
  right: 20px;
  top: 25%;
  font-size: 1.3rem;
  cursor: pointer;
}

.sc_eye {
  width: 20px;
}

#alert {
  position: relative;
  top: 0;
  width: 300px;
  height: 330px;
  padding: 10px;
  box-sizing: border-box;
  color: #eee;
  border-radius: 12px;
  flex-shrink: 1;
  background: rgba(255, 255, 255, 0.95);
  margin-right: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

#alert > h3 {
  text-align: center;
}

#login_container {
  position: relative;
  flex-shrink: 1;
  width: 235px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
  background: #fff;
  height: 353px;
  overflow: hidden;
}

#login_container::before {
  content: "微信扫码登录";
  display: block;
  width: 160px;
  margin: 0 auto;
  text-align: center;
  color: #333;
  padding: 40px 0px 35px;
  font-size: 18px;
  line-height: 20px;
}

#company_login_container {
  display: block;
  position: relative;
  flex-shrink: 1;
  width: 235px;
  border: 5px;
  overflow: hidden;
  height: 362px;
}

#company_login_container::before {
  content: "";
  display: block;
  width: 160px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: 20px;
}

.logo_header {
  height: 0;
  background: transparent;
  position: relative;
}

.logo {
  /* background: url(../../assets/logo.png) no-repeat; */
  /* height: 180px;
  width: 268px; */
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -134px;
  z-index: 2;
}

.login-banner {
  min-height: 100vh;
  flex: 1;
  background: url(../../assets/img/bgzy.jpg) no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 40px 0;
}

.container {
  position: relative;
  margin: 0 auto;
  padding-bottom: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  max-width: 1400px;
  padding-right: 120px;
}

.login-box {
  width: 380px;
  height: auto;
  padding: 30px 40px 40px;
  border-radius: 12px;
  position: relative;
  top: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.login-tab ul {
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  margin-bottom: 24px;
  border-bottom: 2px solid #f0f0f0;
  padding: 0;
}

.login-tab ul li {
  float: none;
  width: auto;
  padding: 0 16px;
  height: 40px;
  font-size: 16px;
  text-align: center;
  color: #999;
  line-height: 40px;
  border-radius: 0;
  margin-right: 0;
  cursor: pointer;
  background: transparent;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
}

.login-tab ul li.active {
  background: transparent;
  color: #00ab71;
  border-bottom: 2px solid #00ab71;
  font-weight: 600;
}

.login_form {
  position: relative;
  height: 46px;
  width: 100%;
  margin: 12px 0;
}

.login_form .iconfontBox {
  width: 46px;
  height: 46px;
  border: 1px solid #e0e0e0;
  border-right: none;
  display: inline-block;
  position: absolute;
  left: 0;
  cursor: default;
  text-align: center;
  line-height: 46px;
  background: #fafafa;
  border-radius: 6px 0 0 6px;
}

.login_form .iconfontBox img {
  vertical-align: middle;
}

.login_form .iconfontBox .iconfont {
  font-size: 20px;
}

.btn-code {
  position: absolute;
  right: 0;
  top: 0;
  height: 46px;
  width: 110px;
  display: inline-block;
  background: #f0f0f0;
  line-height: 46px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  border-radius: 0 6px 6px 0;
  border: 1px solid #e0e0e0;
  border-left: none;
  color: #555;
}

.btn-code.active,
.btn-code:hover {
  background: #00ab71;
  color: #fff;
}

.icon-users {
  background: url(../../assets/icon-user.png) no-repeat center 10px;
  width: 42px;
  height: 42px;
  border: 1px solid #ccc;
  display: inline-block;
  position: absolute;
  left: 0;
  cursor: default;
}

.icon-pwd {
  background: url(../../assets/icon-pwd.png) no-repeat center 10px;
  width: 42px;
  height: 42px;
  border: 1px solid #ccc;
  display: inline-block;
  position: absolute;
  left: 0;
  cursor: default;
}

.login_input {
  width: 100%;
  padding: 12px 12px 12px 58px;
  border: 1px solid #e0e0e0;
  background: #fff;
  font-family: "microsoft yahei", sans-serif;
  font-size: 14px;
  color: #333;
  border-radius: 6px;
  transition: all 0.3s;
}

.login_input:focus {
  outline: none;
  border-color: #00ab71;
  box-shadow: 0 0 0 3px rgba(0, 171, 113, 0.1);
}

.login_btn {
  height: 46px;
  cursor: pointer;
  border-radius: 6px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #00ab71, #00c882);
  border: none;
  line-height: 46px;
  letter-spacing: 4px;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(0, 171, 113, 0.3);
}

.login_btn:hover {
  background: linear-gradient(135deg, #009962, #00ab71);
  box-shadow: 0 6px 16px rgba(0, 171, 113, 0.4);
  transform: translateY(-1px);
}

.code_btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.code_img {
  width: 36px;
  height: 36px;
  margin: 0 8px;
  cursor: pointer;
  transition: transform 0.3s;
  border-radius: 8px;
  padding: 4px;
  background: #f5f5f5;
}

.code_img:hover {
  transform: scale(1.1);
  background: #e8f5f1;
}

.login_p {
  position: absolute;
  top: 245px;
  margin-left: 50px;
  font-size: 16px;
  color: #fff;
}

.third_login {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}

.footer {
  text-align: center;
  padding: 16px 0;
  color: rgba(255, 255, 255, 0.85);
  line-height: 24px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(6px);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.footer ::v-deep .el-link {
  color: rgba(255, 255, 255, 0.9);
}

.footer ::v-deep .el-link:hover {
  color: #00ab71;
}

.automatic {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.automatic /deep/ .el-checkbox .el-checkbox__label {
  color: #666;
}

.automatic /deep/ .is-checked .el-checkbox__input .el-checkbox__inner {
  background: #00ab71;
  border: none;
}

.automatic /deep/ .is-checked .el-checkbox__input .el-checkbox__inner::after {
  left: 5px;
  top: 2px;
}

.automatic /deep/ .is-checked .is-focus {
  border: none;
}

::v-deep .wwLogin_qrcode_head {
  display: none;
}

.login_method {
  position: absolute;
  top: -61px;
  right: -148px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
  display: inline-block;
  width: 130px;
  color: #00ab71;
  z-index: 9999;
}

.change-pwd-tip {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  padding: 10px 12px;
  background: #fdf6ec;
  border-radius: 4px;
  border-left: 4px solid #e6a23c;
}

.login_method:hover {
  color: #00ab71;
}
</style>
